import React, { Component } from 'react'
import AWSAPI from '../../../common/AWSAPI'
import Window from '../../../common/Window'
import Loading from '../../../common/component/Loading'
import Config from '../../../Config'

class SurveyMediumQuestionEdit extends Component {
  constructor (props) {
    super(props)
    const initialState = this.getInitialState()
    this.state = initialState
    this.apiUrl = Config.adminApiUrl.surveyQuestionSetting
    this.userRole = 'admin'
  }
  getInitialState () {
    return {
      isLoaded: false,
      isNew: true,
      id: null,
      bigQuestions: {},
      mediumQuestions: {},
      smallQuestions: {},
      maxId: null,
      maxSort: null,
    }
  }
  componentDidMount() {
    const { id } = this.props.match.params
    if (!id) {
      this.props.history.push('/admin/survey_bigquestion');
    }
    this.loadServey(id)
  }
  loadServey(id) {
    const onSuccess = (res) => {
      // APIから取得したデータをstateに反映
      const surveyData = res.body.data
      this.setState({
        bigQuestions: surveyData.bigQuestions ? surveyData.bigQuestions[0] : null,
        mediumQuestions: surveyData.mediumQuestions ? surveyData.mediumQuestions[0] : null,
        smallQuestions: surveyData.smallQuestions ? surveyData.smallQuestions[0] : null,
        maxId: surveyData.maxId,
        maxSort: surveyData.maxSort,
        isLoaded: true,
      })
      console.log(this.state)
    }
    let params = {}
    const currentPath = this.props.match.path;
    if (currentPath.includes('/add/')) {
      params = {
       command: 'getMediumDetailAdd',
       surveyValue: { id: id }
      }
      this.setState({
        isNew: true,
      })
    } else {
      params = {
        command: 'getMediumDetail',
        surveyValue: { id: id },
      }
      this.setState({
        isNew: false,
      })
    }
    AWSAPI.apiPost(this.userRole, this.apiUrl, params, onSuccess)
  }
  saveServey () {
    const {params} = this.props.match
    const id = params.id
    const servey = this.state
    if (!servey.mediumQuestions || !servey.mediumQuestions.setsumon_text) {
      Window.alert('中設問テキストは必須です')
      return false
    }
    let updateOrInsert
    if(servey.isNew == true) {
      updateOrInsert = (oldSurveyValue) => {
        const newId = Number(servey.maxId || 0) + 1;
        const result = {
          id: newId,
          big_question_id: servey.bigQuestions.id,
          setsumon_text: servey.mediumQuestions.setsumon_text,
          setsumon_comment: servey.mediumQuestions.setsumon_comment,
          createDateTime: servey.mediumQuestions.createDateTime,
          lastUpdateDateTime: servey.mediumQuestions.lastUpdateDateTime,
        }
        return result
      }
    } else { // 更新
      updateOrInsert = (oldSurveyValue) => {
        const result = {
          id: servey.mediumQuestions.id,
          big_question_id: servey.mediumQuestions.big_question_id,
          setsumon_text: servey.mediumQuestions.setsumon_text,
          setsumon_comment: servey.mediumQuestions.setsumon_comment,
          createDateTime: servey.mediumQuestions.createDateTime,
          lastUpdateDateTime: servey.mediumQuestions.lastUpdateDateTime,
        }
        return result
      }
    }
    const onSuccessToGet = (res) => {
      const surveyValue = updateOrInsert(res.body)
      let paramsToSet = [];
      if(servey.isNew == true) {
        paramsToSet = {
          command: 'mediumAdd',
          surveyValue: surveyValue
        }
      } else {
        paramsToSet = {
          command: 'mediumSet',
          surveyValue: surveyValue
        }
      }
      const onSuccessToPost = (res) => {
        Window.alert('保存しました', () => {
          this.props.history.push(`/admin/survey_smallquestion/${surveyValue.id}`)
          Window.closeDialog()
        })
      }
      AWSAPI.apiPost(this.userRole, this.apiUrl, paramsToSet, onSuccessToPost)
    }
    const paramsToGet = {
      command: 'get'
    }
    AWSAPI.apiPost(this.userRole, this.apiUrl, paramsToGet, onSuccessToGet)
  }
  delServey () {
    const {params} = this.props.match
    const id = params.id
    const servey = this.state
    const paramsToSet = {
      command: 'mediumDel',
      surveyValue: servey.mediumQuestions
    }
    const onSuccessToPost = (res) => {
      Window.alert('削除しました', () => {
        this.props.history.push(`/admin/survey_mediumquestion/${this.state.bigQuestions.id}`)
        Window.closeDialog()
      })
    }
    AWSAPI.apiPost(this.userRole, this.apiUrl, paramsToSet, onSuccessToPost)
  }
  onPageMenuClicked (name) {
    const id = this.state.id
    switch (name) {
      case 'back':
        if(this.state.isNew) {
          this.props.history.push(`/admin/survey_mediumquestion/${this.state.bigQuestions.id}`)
        } else {
          this.props.history.push(`/admin/survey_smallquestion/${this.state.mediumQuestions.id}`)
        }
        break
      case 'delete':
        Window.confirm('本当に削除処理を実行しますか?', () => {
          this.delServey()
        })
        break
      default:
        break
    }
  }
  uuid () {
    let uuid = ''
    let i
    let random
    for (i = 0; i < 32; i++) {
      random = Math.random() * 16 | 0

      if (i === 8 || i === 12 || i === 16 || i === 20) {
        uuid += '-'
      }
      uuid += (i === 12 ? 4 : (i === 16 ? ((random & 3) | 8) : random)).toString(16)
    }
    return uuid
  }
  renderSurveyDetail(state) {
    const survey = state;
    // 入力変更時の処理
    const changed = (name, e) => {
      const value = e.target.type === 'radio' ? e.target.value === 'true' : e.target.value;
      const [parentKey, childKey] = name.split('.');

      // ネストされたstateを更新
      this.setState(prevState => ({
        [parentKey]: {
          ...prevState[parentKey],
          [childKey]: value,
        },
      }));
    };
    const title = state.isNew ? '新規登録' : '変更';
    const setsumonTitle = survey.bigQuestions && survey.bigQuestions.setsumon_title ? survey.bigQuestions.setsumon_title : null;
    const setsumonComment = survey.bigQuestions && survey.bigQuestions.setsumon_comment ? survey.bigQuestions.setsumon_comment : null;
    const setsumonSort = survey.bigQuestions && survey.bigQuestions.setsumon_sort ? survey.bigQuestions.setsumon_sort : null;
    const setsumonMediumText = survey.mediumQuestions && survey.mediumQuestions.setsumon_text ? survey.mediumQuestions.setsumon_text : null;
    const setsumonMediumComment = survey.mediumQuestions && survey.mediumQuestions.setsumon_comment ? survey.mediumQuestions.setsumon_comment : null;
    const setsumonText = survey.smallQuestions && survey.smallQuestions.setsumon_text ? survey.smallQuestions.setsumon_text : null;
    const setsumonText2 = survey.smallQuestions && survey.smallQuestions.setsumon_text2 ? survey.smallQuestions.setsumon_text2 : null;
    const setsumonType = survey.smallQuestions && survey.smallQuestions.setsumon_type ? survey.smallQuestions.setsumon_type : null;

    return (
      <fieldset>
        <legend>アンケート設問情報 - {title}</legend>
        <br />
        <div className='control-group row'>
          <label className='span3'>大設問タイトル</label>
          <div className='span8'>
            {setsumonTitle}
          </div>
        </div>
        <div className='control-group row'>
          <label className='span3'>大設問コメント</label>
          <div className='span10'>
            {setsumonComment}
          </div>
        </div>
        <div className='control-group row'>
          <label className='span3'>中設問テキスト <span className='required'>*</span></label>
          <div className='span10'>
            <textarea name='setsumonText' className='span10' value={setsumonMediumText} onChange={e => changed('mediumQuestions.setsumon_text', e)} />
          </div>
        </div>
        <div className='control-group row'>
          <label className='span3'>中設問コメント</label>
          <div className='span10'>
            <textarea name='setsumonComment' className='span10' value={setsumonMediumComment} onChange={e => changed('mediumQuestions.setsumon_comment', e)} />
          </div>
        </div>
      </fieldset>
    );
  }
  onFormButtonClicked (name, e) {
    e.preventDefault()
    const id = this.state.id
    switch (name) {
      case 'save':
        this.saveServey()
        break
      case 'cancel':
        if(this.state.isNew) {
          this.props.history.push(`/admin/survey_mediumquestion/${this.state.bigQuestions.id}`)
        } else {
          this.props.history.push(`/admin/survey_smallquestion/${this.state.mediumQuestions.id}`)
        }
        break
      default:
        break
    }
  }
  render () {
    if (!this.state.isLoaded) {
      return <Loading />
    }
    const surveyDetail = this.renderSurveyDetail(this.state)
    const title = this.state.isNew ? '新規登録' : '変更'
    return (
      <div>
        <section className='nav-page'>
          <div className='container'>
            <div className='row'>
              <div className='span7'>
                <header className='page-header'>
                  <h3>アンケート情報 - {title}<br /><small>こちらでアンケート情報を{title}できます。</small></h3>
                </header>
              </div>
              <div className='span9'>
                <ul className='nav nav-pills'>
                  {this.state.mediumQuestions && this.state.mediumQuestions.createDateTime && (
                    <li className='kw-btn-area'><button rel='tooltip' data-placement='left' title='削除' className='text-center kw-btn-danger' onClick={(e) => this.onPageMenuClicked('delete')}><i className='icon-remove icon-large' /><span>削除</span></button></li>
                  )}
                  <li className='kw-btn-area'><button rel='tooltip' data-placement='left' title='戻る' className='text-center kw-btn-primary' onClick={(e) => this.onPageMenuClicked('back')}><i className='icon-arrow-left icon-large' /><span>戻る</span></button></li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        <section className='page container'>
          <form className='form-horizontal' method='post'>
            <div className='container'>
              <div className='kw-ic-info-regist-area span16'>
                <div className='alert alert-block alert-info'>
                  <p>必要な情報を入力して最後に「保存」ボタンを押してください。「<span className='required'>*</span>」マークは必須項目です。</p>
                </div>
                {surveyDetail}
                <footer className='form-actions' id='submit-actions'>
                  <button className='btn btn-primary' onClick={(e) => this.onFormButtonClicked('save', e)} >保存</button>
                  <button className='btn btn-default' onClick={(e) => this.onFormButtonClicked('cancel', e)}>キャンセル</button>
                </footer>
              </div>
            </div>
          </form>
        </section>
      </div>
    )
  }
}

export default SurveyMediumQuestionEdit



// WEBPACK FOOTER //
// ./src/admin/pages/secure/SurveyMediumQuestionEdit.js